module.exports = __webpack_public_path__ + "img/official-website_even.157bbd26.svg";